/**
 * src/main.tsx — the entry point.
 *
 * Source: `D:/WCS/latex2html-french-trad/src/main.tsx` (whole file, 5 lines).
 * Spec:   `docs/spec/06-frontend-components.md` §1.1.
 *
 * ═══ NO `<StrictMode>` — THIS IS A REQUIREMENT, NOT A PREFERENCE (spec §1.1) ═════════════════
 * The source renders `<App />` bare (`main.tsx:5`). Three ported effects are written assuming a
 * single invocation and StrictMode double-invokes all of them in development:
 *   • `HtmlPreview`'s `doc.open()/write()/close()` (`HtmlPreview.tsx:12-40`) — writing the iframe
 *     document twice per commit compounds DF-22 rank 4's scroll-jump and double-fetches the KaTeX
 *     CDN stylesheet, so the defect under validation would not look like the shipped app's.
 *   • `LatexEditor`'s keydown listener (`LatexEditor.tsx:12-32`), attached/detached per keystroke.
 *   • `HexclaveAuthProvider`'s mount effect, which would fire two
 *     `GET /api/auth/me` requests and can delete a valid token twice on a slow network.
 * The Phase-2 scaffold added StrictMode; it is removed here to match the source.
 *
 * `./index.css` is the only stylesheet imported (`main.tsx:3`). The source also has `src/App.css`,
 * which is **imported nowhere** and is dead — it is not ported (spec §1.1, §13).
 *
 * The source writes `document.getElementById("root")!` with a non-null assertion. The null guard
 * below is the port's only change to this file: `index.html:15` always provides `#root`, so the
 * throw is unreachable, and it exists solely because `strictNullChecks` rejects the `!` idiom under
 * this repo's lint rules. Behaviour is identical in every reachable case.
 */
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root not found in index.html')

createRoot(root).render(<App />)
